<app-public-page-template [headerText]="'Reset password'">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group form-row">
      <label for="emailAddress"><h3>Email Address:</h3></label>
      <div class="form-group input-group">
        <input autocomplete="current-password"
          class="form-control"
          id="emailAddress"
          placeholder="{{emailAddressDisplayed}}"
          readonly="readonly"
          type="text"/>
      </div>
    </div>
    <div class="form-group form-row">
      <label for="password"><h3>Enter New Password:</h3></label>
      <div class="form-group input-group">
        <input [ngClass]="{ 'is-invalid': displayError(f.password) }"
          autocomplete="new-password"
          class="form-control"
          formControlName="password"
          id="password"
          placeholder=""
          type="password"/>
        @if (displayError(f.password)) {
          <div class="invalid-feedback">
            @if (f.password.errors.required) {
              <div>Password is required</div>
            }
            @if (f.password.errors.invalidPassword) {
              <div>{{ f.password.errors.invalidPassword }}</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group form-row">
      <label for="password-confirm"><h3>Confirm New Password:</h3></label>
      <div class="form-group input-group">
        <input [ngClass]="{ 'is-invalid': displayError(f.confirmPassword)}"
          autocomplete="new-password"
          class="form-control"
          formControlName="confirmPassword"
          id="password-confirm"
          placeholder=""
          type="password"/>
        @if (displayError(f.confirmPassword)) {
          <div class="invalid-feedback">
            @if (f.confirmPassword.errors.required) {
              <div>Please confirm your password
              </div>
            }
            @if (f.confirmPassword.errors.passwordMismatch) {
              <div>Password does not match
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group form-row action-button-group">
      <button class="navy-btn col-5" type="submit">
        Submit <i [hidden]="!loading" class="fa fa-spinner fa-spin" style="font-size:15px"></i>
      </button>
      <button [routerLink]="routes.PUBLIC.LOGIN.path" class="navy-btn col-4" type="button">
        Cancel
      </button>
    </div>
  </form>
</app-public-page-template>
